import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  user: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    justifyContent: 'left',
    flexDirection: 'row',
    margin: 0,
    padding: 0
  },
  content: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginLeft: theme.spacing.sm
  },
  nameWrapper: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  ldapLabel: {
    position: 'absolute',
    left: 16,
    bottom: -10,
    backgroundColor: 'rgba(51, 154, 240, 1)',
    color: '#EFF8FF',
    fontWeight: 500,
    lineHeight: '18px',
    padding: '0 6px',
    borderRadius: '16px',
    fontSize: '10px',
    flexShrink: 0
  }
}));
